var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background-color":"#F5F6FA","display":"flex","flex-direction":"column","height":"100%"}},[_c('hear',{attrs:{"num":1}}),_vm._v(" "),_c('BDhear',{attrs:{"num":1}}),_vm._v(" "),(_vm.cion)?_c('div',{staticStyle:{"flex":"1"}},[_c('SelectALot')],1):_c('div',{staticStyle:{"flex":"1"}},[_c('SelectALots')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-117c8e38","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/BidSecurity/BidSecurity.vue
// module id = null
// module chunks = 